import {eachDayOfInterval, format} from 'date-fns';
import {LocalDateTimeString, LocalDateString} from './apiTypes';
import {LocalTimespan} from './stateTypes';

export const dateKeyForDateTimeString = (dt: LocalDateTimeString): LocalDateString => {
  return dt.slice(0, 'yyyy-MM-dd'.length);
};

export const localDateTimeStringToHHMMss = (dt: LocalDateTimeString): string => {
  return format(new Date(dt), 'HH:mm:ss');
};

export const localDateTimeStringToHHMM = (dt: LocalDateTimeString): string => {
  return format(new Date(dt), 'HH:mm');
};

export const datesForRange = ({from, to}: LocalTimespan): Array<LocalDateString> => {
  return eachDayOfInterval({start: new Date(from), end: new Date(to)}).map((d) => format(d, 'yyyy-MM-dd'));
};

export const isFullDay = (s: LocalDateTimeString, e: LocalDateTimeString): boolean => {
  const dayStart = s.endsWith('00:00') || s.endsWith('00:00:00');
  const dayEnd = e.endsWith('23:59') || e.endsWith('23:59:00');
  return dayStart && dayEnd;
};

export const localDateStringToStartOfDay = (d: LocalDateString): LocalDateTimeString => {
  return `${d}T00:00:00`;
};

export const localDateStringToEndOfDay = (d: LocalDateString): LocalDateTimeString => {
  return `${d}T23:59:00`;
};

export const dateToLocalDateTimeString = (date: Date): LocalDateTimeString => {
  return format(date, `yyyy-MM-dd'T'HH:mm:ss`);
};

export const dateToLocalDateString = (date: Date): LocalDateString => {
  return format(date, 'yyyy-MM-dd');
};
